import $ from 'jquery';

export default () => {     
    function calculateMarginBottom() {
        $("#main-content").css("margin-bottom", $("footer").outerHeight() + "px");
    }
    $(window).on("load resize", calculateMarginBottom());
}


// WEBPACK FOOTER //
// ../views/partials/footer/footer.js